import { useMutation, useQueryClient } from '@tanstack/react-query';

import * as Filtrator from '@Stores/Filtrator';
import Configurator from '@Api/Configurator';
import * as PageProductStore from '@Stores/PageProduct';
import { useRequest } from '@Contexts/Request';

import type { FilterResultData } from '@Api/Configurator/getFilterResult';
import type { ProductData } from '@Types/Product';

const useResetFilters = (id: ProductData['id']) => {
  const entityId = 'configurator-textile';
  const { region } = useRequest();
  const queryClient = useQueryClient();
  const {
    configuratorOnPage: { fabricFilters, fabricCollections, parameterValues },
    product: { modelId },
  } = PageProductStore.useData();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      const res = await Configurator.getFilterResultCount({
        shopProductId: id,
        params: {},
      });
      return res;
    },
    onSuccess: (res) => {
      queryClient.setQueryData<FilterResultData>(['selected-filters', modelId, region], () => ({
        parameterValues,
        fabricCollections,
        filters: fabricFilters,
      }));
      Filtrator.changeCount(entityId, { ...res.fabricFilters, totalCount: res.count });
    },
  });

  return {
    resetFilters: mutate,
    isPending,
  };
};

export default useResetFilters;
